const config = {
  API_BASE_URL: 'https://testapi.goerp.live/api',
  // The website renderer (Webthemebuilder). The builder's preview pane points
  // at it, so what the property sees while editing is the very app that will
  // serve the published site - not a second drawing of the same sections.
  // Only the base address lives here; the preview adds the logged-in
  // company's own /@username. Local dev server on localhost, the live
  // renderer everywhere else - so a build never needs this line switched.
  WEB_RENDERER_URL: window.location.hostname === 'localhost'
    ? 'http://localhost:4000'
    : 'https://restaurant.goerp.live',
  // Where a property's public website lives by default: <this>/@username.
  // A property's own domain replaces it once they give us one. Must match the
  // renderer's BASE_HOST (Webthemebuilder/.env).
  WEBSITE_BASE_HOST: 'restaurant.goerp.live',
  LOGIN_API: '/auth/login',
  REGISTER_API: '/auth/register',
  PRODUCT_LIST_API: '/products',
  ORDER_SAVE_API: '/orders/save',
};

export default config;
